<template>
    <div class="closed-sign" :class="{ 'is-dark': dark, 'is-break': isBreak }">
        <div class="cs-stage" v-if="!isBreak">
            <div class="cs-swing">
                <svg class="cs-wires cs-wires-d" viewBox="0 0 380 90" width="380" height="90" aria-hidden="true">
                    <line x1="190" y1="6" x2="24" y2="78" stroke-width="3" style="stroke:var(--cs-ink)"></line>
                    <line x1="190" y1="6" x2="356" y2="78" stroke-width="3" style="stroke:var(--cs-ink)"></line>
                </svg>
                <svg class="cs-wires cs-wires-m" viewBox="0 0 260 90" width="260" height="90" aria-hidden="true">
                    <line x1="130" y1="6" x2="24" y2="80" stroke-width="3" style="stroke:var(--cs-ink)"></line>
                    <line x1="130" y1="6" x2="236" y2="80" stroke-width="3" style="stroke:var(--cs-ink)"></line>
                </svg>
                <div class="cs-nail"></div>
                <div class="cs-sign">
                    <img class="cs-logo" :src="logoSrc" alt="Black Pizza">
                    <div class="cs-wordcol">
                        <div class="cs-word">ЗАЧИНЕНО</div>
                        <div class="cs-bar"></div>
                    </div>
                </div>
            </div>
            <div class="cs-msg">
                <div class="cs-title">{{ title }}</div>
                <div class="cs-text">{{ text }}</div>
                <button type="button" class="cs-btn" @click="$emit('close')">Переглянути меню</button>
            </div>
        </div>
        <div class="cs-stage" v-else>
            <div class="cs-clock">
                <div class="cs-pie">
                    <div v-for="n in 8" :key="n" class="cs-psec" :data-i="n - 1"
                         :style="{ transform: 'rotate(' + (n - 1) * 45 + 'deg)', opacity: n === 1 ? 1 : 0 }">
                        <i v-for="(dot, di) in ((n - 1) % 2 ? dotsB : dotsA)" :key="di" class="cs-dot" :style="dot"></i>
                    </div>
                    <div v-for="deg in cuts" :key="deg" class="cs-cut" :style="{ transform: 'rotate(' + deg + 'deg)' }"></div>
                </div>
                <div class="cs-hand"></div>
                <div class="cs-hub"></div>
            </div>
            <div class="cs-copy">
                <div class="cs-head">
                    <div class="cs-bw-clip"><div class="cs-bw">ПЕРЕРВА</div></div>
                    <div class="cs-bl"></div>
                </div>
                <div class="cs-title">{{ title }}</div>
                <div class="cs-text cs-reveal">{{ text }}</div>
                <button type="button" class="cs-btn cs-reveal" @click="$emit('close')">Переглянути меню</button>
            </div>
        </div>
    </div>
</template>

<script>
// Екран «сайт закритий»: 6a табличка на цвяху, 6b піца-таймер. Кадри — play_cl / play_br.
var DOT_A = [
    'left:107px;top:33px;width:26px;height:26px;background:#7a1212;box-shadow:inset 0 0 0 2px #5e0d0d',
    'left:102px;top:76px;width:16px;height:16px;background:#7a1212;box-shadow:inset 0 0 0 2px #5e0d0d',
    'left:122px;top:65.5px;width:16px;height:9px;background:#f6c945;transform:rotate(20deg)',
    'left:110px;top:24.5px;width:12px;height:7px;background:#f6c945;transform:rotate(-15deg)',
    'left:119.5px;top:95px;width:9px;height:6px;background:#f6c945;transform:rotate(40deg)'
];
var DOT_B = [
    'left:112px;top:54px;width:24px;height:24px;background:#7a1212;box-shadow:inset 0 0 0 2px #5e0d0d',
    'left:106px;top:26px;width:16px;height:16px;background:#7a1212;box-shadow:inset 0 0 0 2px #5e0d0d',
    'left:102.5px;top:48px;width:15px;height:8px;background:#f6c945;transform:rotate(-25deg)',
    'left:124.5px;top:88.5px;width:11px;height:7px;background:#f6c945;transform:rotate(10deg)',
    'left:121px;top:21px;width:10px;height:6px;background:#f6c945;transform:rotate(30deg)'
];

export default {
    name: 'ClosedSign',
    props: {
        variant: { type: String, default: '6a' },
        title: { type: String, default: '' },
        text: { type: String, default: '' },
        dark: { type: Boolean, default: false }
    },
    data: function () {
        return { dotsA: DOT_A, dotsB: DOT_B, cuts: [-67.5, -22.5, 22.5, 67.5] };
    },
    computed: {
        isBreak: function () { return this.variant === '6b'; },
        logoSrc: function () {
            var base = process.env.BASE_URL || '/';
            if (base.slice(-1) !== '/') base += '/';
            return base + 'intro/logo/' + (this.dark ? 'full.webp' : 'full-w.webp');
        }
    },
    mounted: function () {
        this.injectFont();
        document.addEventListener('keydown', this.onKey);
        this._anims = [];
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduce || !this.$el.animate) return;
        if (this.isBreak) this.playBreak();
        else this.playSign();
    },
    beforeDestroy: function () {
        document.removeEventListener('keydown', this.onKey);
        (this._anims || []).forEach(function (a) { a.cancel(); });
        this._anims = [];
    },
    methods: {
        onKey: function (e) {
            if (e.key === 'Escape' && !e.repeat) this.$emit('close');
        },
        injectFont: function () {
            if (document.getElementById('bp-archivo')) return;
            var link = document.createElement('link');
            link.id = 'bp-archivo';
            link.rel = 'stylesheet';
            link.href = 'https://fonts.googleapis.com/css2?family=Archivo:wght@800&display=swap';
            document.head.appendChild(link);
        },
        anim: function (el, kf, o) {
            var a = el.animate(kf, {
                duration: o.d,
                delay: o.delay || 0,
                easing: o.e || 'cubic-bezier(.2,.8,.2,1)',
                fill: o.fill || 'both'
            });
            this._anims.push(a);
            return a;
        },
        playSign: function () {
            var self = this;
            this.$el.querySelectorAll('.cs-swing').forEach(function (el) {
                self.anim(el, [
                    { transform: 'translateY(-420px) rotate(0deg)', easing: 'cubic-bezier(.55,0,1,.45)' },
                    { transform: 'translateY(0px) rotate(0deg)', offset: 0.18, easing: 'ease-out' },
                    { transform: 'translateY(0px) rotate(14deg)', offset: 0.3, easing: 'ease-in-out' },
                    { transform: 'translateY(0px) rotate(-10deg)', offset: 0.45, easing: 'ease-in-out' },
                    { transform: 'translateY(0px) rotate(6deg)', offset: 0.6, easing: 'ease-in-out' },
                    { transform: 'translateY(0px) rotate(-3deg)', offset: 0.74, easing: 'ease-in-out' },
                    { transform: 'translateY(0px) rotate(1.2deg)', offset: 0.87, easing: 'ease-in-out' },
                    { transform: 'translateY(0px) rotate(0deg)' }
                ], { d: 2400, e: 'linear' });
                // Після приземлення — безкінечне погойдування від цвяха
                self._anims.push(el.animate([
                    { transform: 'translateY(0px) rotate(-1.5deg)' },
                    { transform: 'translateY(0px) rotate(1.5deg)' }
                ], {
                    duration: 3000,
                    delay: 2400,
                    easing: 'ease-in-out',
                    iterations: Infinity,
                    direction: 'alternate',
                    fill: 'none'
                }));
            });
            this.$el.querySelectorAll('.cs-msg').forEach(function (el) {
                self.anim(el, [
                    { transform: 'translateY(16px)', opacity: 0 },
                    { transform: 'none', opacity: 1 }
                ], { d: 500, delay: 900 });
            });
        },
        playBreak: function () {
            var self = this;
            var root = this.$el;
            var T = 2800, a0 = 22.5;
            root.querySelectorAll('.cs-hand').forEach(function (el) {
                self.anim(el, [
                    { transform: 'rotate(' + a0 + 'deg)', opacity: 1 },
                    { transform: 'rotate(337.5deg)', opacity: 1, offset: 0.9 },
                    { transform: 'rotate(345deg)', opacity: 0 }
                ], { d: T, delay: 500, e: 'cubic-bezier(.45,0,.55,1)' });
            });
            root.querySelectorAll('.cs-pie').forEach(function (el) {
                self.anim(el, [
                    { transform: 'scale(.6) rotate(-90deg)', opacity: 0 },
                    { transform: 'none', opacity: 1 }
                ], { d: 500, e: 'cubic-bezier(.2,1.2,.4,1)' });
            });
            root.querySelectorAll('.cs-psec').forEach(function (el) {
                var i = +el.getAttribute('data-i');
                if (!i) return;
                var t = 500 + T * ((i * 45 + 22.5 - a0) / (360 - a0));
                self.anim(el, [
                    { transform: 'rotate(' + (i * 45) + 'deg) scale(1)', opacity: 1 },
                    { transform: 'rotate(' + (i * 45) + 'deg) scale(.82)', opacity: 0 }
                ], { d: 260, delay: t - 130, e: 'ease-in' });
            });
            root.querySelectorAll('.cs-psec').forEach(function (el) {
                if (+el.getAttribute('data-i')) return;
                self._anims.push(el.animate([
                    { transform: 'rotate(0deg) scale(1)' },
                    { transform: 'rotate(0deg) scale(1.05)' },
                    { transform: 'rotate(0deg) scale(1)' }
                ], { duration: 1400, delay: 500 + T, iterations: Infinity, easing: 'ease-in-out' }));
            });
            root.querySelectorAll('.cs-bw').forEach(function (el) {
                self.anim(el, [{ transform: 'translateY(105%)' }, { transform: 'none' }], { d: 600, delay: 250 });
            });
            root.querySelectorAll('.cs-bl').forEach(function (el) {
                self.anim(el, [{ transform: 'scaleX(0)' }, { transform: 'scaleX(1)' }], { d: 500, delay: 550, e: 'cubic-bezier(.7,0,.2,1)' });
            });
            root.querySelectorAll('.cs-title').forEach(function (el) {
                self.anim(el, [
                    { transform: 'translateY(14px)', opacity: 0 },
                    { transform: 'none', opacity: 1 }
                ], { d: 500, delay: 700 });
            });
            root.querySelectorAll('.cs-reveal').forEach(function (el) {
                self.anim(el, [
                    { transform: 'translateY(14px)', opacity: 0 },
                    { transform: 'none', opacity: 1 }
                ], { d: 500, delay: 820 });
            });
        }
    }
};
</script>

<style scoped>
.closed-sign {
    --cs-bg: #ffffff;
    --cs-ink: #201e1d;
    --cs-muted: #605d5d;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 2000;
    /* Якщо вікно нижче за сцену (телефон у ландшафті, короткий екран із довгим заголовком),
       табличку можна догорнути до кнопки; сторінку позаду не гортаємо */
    overflow-x: hidden;
    overflow-y: auto;
    overscroll-behavior: contain;
    background: var(--cs-bg);
    color: var(--cs-ink);
    font-family: system-ui, sans-serif;
}
.closed-sign.is-dark {
    --cs-bg: #201e1d;
    --cs-ink: #ffffff;
    --cs-muted: #bab6b6;
}
.cs-stage {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 720px;
    height: 450px;
    margin: -225px 0 0 -360px;
}
.cs-swing {
    position: absolute;
    left: 168px;
    top: 18px;
    width: 380px;
    height: 230px;
    transform-origin: 190px 6px;
}
.cs-wires {
    position: absolute;
    left: 0;
    top: 0;
    display: block;
    overflow: visible;
}
.cs-wires line { stroke: var(--cs-ink); }
.cs-wires-m { display: none; }
.cs-nail {
    position: absolute;
    left: 184px;
    top: 0;
    z-index: 2;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: var(--cs-ink);
}
.cs-sign {
    position: absolute;
    left: 0;
    top: 74px;
    z-index: 1;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    box-sizing: border-box;
    width: 380px;
    height: 132px;
    padding: 0 24px;
    background: var(--cs-ink);
}
.cs-logo {
    display: block;
    flex: none;
    width: 88px;
    height: 83px;
    max-width: none;
}
.cs-wordcol {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
}
.cs-word {
    font-family: Archivo, system-ui, sans-serif;
    font-weight: 800;
    font-size: 36px;
    line-height: 1;
    letter-spacing: 0.02em;
    color: var(--cs-bg);
}
.cs-bar {
    width: 100%;
    height: 4px;
    background: #ac1e1e;
}
.cs-msg {
    position: absolute;
    left: 0;
    right: 0;
    top: 272px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    padding: 0 48px;
    text-align: center;
}
.cs-title {
    max-width: 100%;
    font-family: Archivo, system-ui, sans-serif;
    font-weight: 800;
    font-size: 30px;
    line-height: 1.15;
    color: var(--cs-ink);
    text-wrap: balance;
}
.cs-text {
    max-width: 520px;
    font-size: 18px;
    line-height: 1.5;
    color: var(--cs-muted);
    text-wrap: pretty;
}
.cs-btn {
    margin-top: 6px;
    padding: 14px 22px;
    border: none;
    border-radius: 0;
    background: var(--cs-ink);
    color: var(--cs-bg);
    font-family: Archivo, system-ui, sans-serif;
    font-weight: 800;
    font-size: 16px;
    line-height: 1;
    letter-spacing: 0.02em;
    cursor: pointer;
    appearance: none;
}
.cs-clock {
    position: absolute;
    left: 56px;
    top: 103px;
    width: 240px;
    height: 240px;
}
.cs-pie { position: absolute; inset: 0; }
.cs-psec {
    position: absolute;
    inset: 0;
    border-radius: 50%;
    background: radial-gradient(circle closest-side, #ac1e1e 0 79%, #2e2622 80% 88%, #201e1d 89%);
    clip-path: polygon(50% 50%, 29.3% 0, 70.7% 0);
}
.cs-dot {
    position: absolute;
    border-radius: 50%;
}
.cs-cut {
    position: absolute;
    left: -10px;
    top: 118px;
    width: 260px;
    height: 4px;
    background: var(--cs-bg);
}
.cs-hand {
    position: absolute;
    left: 118px;
    top: 12px;
    width: 4px;
    height: 108px;
    background: var(--cs-ink);
    transform-origin: 50% 100%;
    opacity: 0;
}
.cs-hub {
    position: absolute;
    left: 111px;
    top: 111px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: var(--cs-ink);
}
.cs-copy {
    position: absolute;
    left: 360px;
    top: 0;
    right: 40px;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 14px;
}
.cs-head {
    display: flex;
    flex-direction: column;
    gap: 14px;
    width: max-content;
    max-width: 100%;
}
.cs-bw-clip { overflow: hidden; }
.cs-bw {
    font-family: Archivo, system-ui, sans-serif;
    font-weight: 800;
    font-size: 64px;
    line-height: 1;
    letter-spacing: -0.01em;
    color: var(--cs-ink);
}
.cs-bl {
    width: 100%;
    height: 4px;
    background: #ac1e1e;
    transform-origin: 0 50%;
}
.cs-copy .cs-title { font-size: 30px; line-height: 1.15; }
.cs-copy .cs-text { max-width: none; }

@media (max-width: 640px) {
    .cs-stage {
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        margin: 0;
    }
    .cs-swing {
        left: 50%;
        top: 114px;
        width: 260px;
        height: 320px;
        margin-left: -130px;
        transform-origin: 130px 6px;
    }
    .cs-wires-d { display: none; }
    .cs-wires-m { display: block; }
    .cs-nail { left: 124px; }
    .cs-sign {
        top: 76px;
        flex-direction: column;
        justify-content: center;
        gap: 14px;
        width: 260px;
        height: 230px;
        padding: 20px;
    }
    .cs-logo { width: 110px; height: 104px; }
    .cs-wordcol { align-items: center; gap: 14px; }
    .cs-bar { width: 96px; }
    .cs-msg {
        top: 480px;
        gap: 12px;
        padding: 0 28px 24px;
    }
    .cs-clock {
        left: 50%;
        top: 140px;
        margin-left: -120px;
    }
    .cs-copy {
        left: 28px;
        right: 28px;
        top: 440px;
        bottom: auto;
        padding-bottom: 24px;
        align-items: center;
        text-align: center;
    }
    .cs-bl { transform-origin: 50% 50%; }
    .cs-bw { font-size: 56px; }
}
/* Короткі телефонні екрани (Safari з панелями, 375×667, 390×664): табличку вище,
   щоб «Переглянути меню» вміщалася без гортання */
@media (max-width: 640px) and (max-height: 760px) {
    .cs-swing { top: 40px; }
    .cs-msg { top: 392px; }
    .cs-clock { top: 64px; }
    .cs-copy { top: 364px; }
}
@media (max-width: 640px) and (max-height: 660px) {
    .cs-swing { top: 16px; }
    .cs-sign { height: 180px; gap: 10px; padding: 16px; }
    .cs-logo { width: 80px; height: 75px; }
    .cs-msg { top: 300px; gap: 10px; }
    .cs-msg .cs-title { font-size: 26px; }
    .cs-msg .cs-text { font-size: 16px; }
    .cs-clock { top: 16px; transform: scale(.75); transform-origin: 50% 0; }
    .cs-copy { top: 216px; gap: 10px; }
    .cs-bw { font-size: 48px; }
}
/* Телефон у ландшафті: без дротів і цвяха, повідомлення одразу під табличкою */
@media (min-width: 641px) and (max-height: 520px) {
    .cs-stage { top: 0; height: 100%; min-height: 340px; margin-top: 0; }
    .cs-swing { top: -56px; }
    .cs-wires, .cs-nail { visibility: hidden; }
    .cs-msg { top: 170px; padding-bottom: 20px; }
    .cs-clock { top: 50%; margin-top: -120px; }
}
</style>
